#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment newsPreview on news_Entry {
    ... baseEntryFields
    featuredImage {
        ... image
    }
    shortDescription
}
